import { LockedModulePanel } from '../LockedModulePanel';

const LOCKED_TAB_CONFIG: Record<string, { moduleName: string; description: string; features: string[] }> = {
    inspections: {
        moduleName: 'Inspections',
        description: 'This unit is archived. Inspections are disabled.',
        features: ['Inspection reports', 'Issue tracking', 'UM counter updates'],
    },
    'daily-service': {
        moduleName: 'Daily Service',
        description: 'This unit is archived. Daily service logs are disabled.',
        features: ['Daily service logs', 'Consumable tracking', 'UM counter updates'],
    },
    pm: {
        moduleName: 'Preventive Maintenance',
        description:
            'Unlock PM scheduling, service level configuration, parts tracking, and automated email notifications for this equipment.',
        features: [
            'PM service queue & scheduling',
            'Service level configuration',
            'Parts & vendor management',
            'Due soon & overdue notifications',
        ],
    },
    tires: {
        moduleName: 'Tire Maintenance',
        description:
            'Unlock tire tracking, tread depth monitoring, axle configuration, and tire assignment for this equipment.',
        features: [
            'Tire inventory & assignment',
            'Tread depth monitoring',
            'Axle configuration builder',
            'Tire lifecycle tracking',
        ],
    },
    'cost-expense': {
        moduleName: 'Cost Tracking',
        description: 'Unlock cost tracking, expense categorization, and financial reporting for this equipment.',
        features: [
            'Usage totals by period (YTD, last 7 / 30 days, custom)',
            'Expense logging & categorization',
            'Cost-per-mile / cost-per-hour',
            'Vendor & parts cost tracking',
            'Financial reports & exports',
        ],
    },
};

export const EquipmentLockedTabContent = ({ tabId }: { tabId: string }) => {
    const config = LOCKED_TAB_CONFIG[tabId];
    if (!config) return null;

    return (
        <LockedModulePanel moduleName={config.moduleName} description={config.description} features={config.features} />
    );
};
